var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"candidate-info"},[_vm._m(0),_c('span',{class:{ truncate: _vm.shortVersion }},[_vm._v(_vm._s(_vm.candidate.city || "-"))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"candidate-info-icon"},[_c('img',{attrs:{"src":require("@/assets/icons/genicon-icons8-location.svg"),"alt":"location"}})])
}]

export { render, staticRenderFns }